import { Component, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { OrganizationCustomizationService } from "@onsip/common/services/api/resources/organizationCustomization/organization-customization.service";

const DEFAULT_COLOR = "#6b80ff";

@Component({
  selector: "onsip-teampage-color-picker",
  templateUrl: "./teampage-color-picker.component.html",
  styleUrls: ["./teampage-color-picker.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TeampageColorPickerComponent implements OnInit {
  @Output() colorChange = new EventEmitter<string>();
  defaultColors: Array<string> = [
    "#136eaf",
    DEFAULT_COLOR,
    "#2446AD",
    "#c472d5",
    "#ffe100",
    "#fd9776"
  ];
  color!: Observable<string>;

  constructor(private organizationCustomization: OrganizationCustomizationService) {}

  ngOnInit() {
    this.organizationCustomization.organizationCustomizationRead();
    this.color = this.organizationCustomization.organization.pipe(
      map(organizationCustomization => {
        const accentColor = organizationCustomization.organizationInfo?.teamPageInfo?.accentColor;
        return typeof accentColor === "string" ? accentColor : DEFAULT_COLOR;
      })
    );
  }
}
